import { render, staticRenderFns } from "./PbDashboardCard.vue?vue&type=template&id=59ebe1e0&scoped=true&"
import script from "./PbDashboardCard.js?vue&type=script&lang=js&"
export * from "./PbDashboardCard.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=59ebe1e0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ebe1e0",
  null
  
)

export default component.exports